import {
  BackgroundImageOverlay,
  LogoImage,
  LogoWrapper,
  PartnerItemRoot,
} from './styles';

import { useState } from 'react';

interface PartnerItemProps {
  link: string;
  onClick?: () => void;
  lightMode?: boolean;
  partnerMode?: boolean;
  noBorder?: boolean;
  borderRadius?: string;
  width?: string;
  height?: string;
}

const PartnerItem = ({
  link,
  onClick,
  lightMode,
  partnerMode,
  noBorder,
  borderRadius,
  width,
  height,
}: PartnerItemProps) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  return (
    <article>
      <PartnerItemRoot
        onMouseOver={() => {
          setIsHovered(true);
        }}
        onMouseOut={() => {
          setIsHovered(false);
        }}
        onClick={onClick}
        $noBorder={noBorder}
        $borderRadius={borderRadius}
        $lightMode={lightMode}
        $partnerMode={partnerMode}
        $width={width}
        $height={height}
      >
        <BackgroundImageOverlay $isHovered={isHovered} />
        {link?.length > 0 && (
          <LogoWrapper>
            <LogoImage src={link} alt="Partner Logo" />
          </LogoWrapper>
        )}
      </PartnerItemRoot>
    </article>
  );
};

export default PartnerItem;
